import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { first } from 'rxjs/internal/operators/first';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { PromoContentService } from '../../../core/routing/services/asset-library/promo-content.service';
import { CreatePromoContentResponse, PromoContent, PromoContentConfiguration, PromoContentViewModel } from '../../asset-library/promo-content/interfaces/promo-content.i';
import { OemService } from '../../../../app/core/routing/services/oem/oem.service';
import { ModelSKU } from '../interface/oem-portal-interface.i';
import { FormBuilder, FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';
import { PartnerContent, PartnerContentConfiguration, CreatePartnerContentContentResponse, TileThumbnailPreview } from './interfaces/new-partner-content.i';
import { NgbModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { RouterConstants } from '../../../core/routing/constants/app-paths.constant';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { TileThumbnail, CreateTileThumbnailResponse, GetAllTileThumbnailByAutoId, AssetThumbnailViewModel } from '../new-model-sku/upload-thumbnail/interfaces/upload-thumbnai.i';
import { OemConstants } from '../../../core/routing/services/oem/constants/oem.constants';
import { CommonService } from '../../../common/services/common.service';
import { GoogleAnalyticsService } from '../../google-analytics/google-analytics.service';

@Component({
  selector: 'iposcen-new-partner-content',
  templateUrl: './new-partner-content.component.html',
  styleUrls: ['./new-partner-content.component.scss']
})
export class NewPartnerContentComponent implements OnInit {
  @Input() isNavigated: boolean;
  @Output() readonly editDone = new EventEmitter();
  @Output() readonly goBacktoPromoContent = new EventEmitter<object>();
  @Output() readonly goBacktoListPartnerContent = new EventEmitter<object>();
  @Output() readonly showAuthorTabs = new EventEmitter();
  @Output() readonly isNewPartnerContent = new EventEmitter();
  @Output() readonly isAllSelectLang = new EventEmitter();
  @Output() readonly changedContentName = new EventEmitter();
  @ViewChild('profileLanguageModal') profileLanguageModal: ElementRef;
  @ViewChild('contentNameInput') contentNameInput: ElementRef;
  @Input() editCG: boolean;
  @Input() duplicacy: boolean;
  isAllLanguagesSelected = false;
  isSubmitted = false;
  modelSkuList = [];
  @Input() getEditData;
  openSelectLangPopup = false;
  emptyAssetsText = OemConstants.NO_ASSETS;
  private ngUnsubscribe = new Subject<boolean>();
  valueModelSKUInfo: any;
  selectedAutoId: string;
  selectedSystemId: string;
  modelSkuListDataByAutoId: ModelSKU[] = [];
  displayName: string;
  englishDisplayName: string;
  systemModel: any;
  displaySytemModel: any;
  isSystemIdSelected: boolean;
  partnerContentgrpForm: FormGroup
  selectTileThumbnailPopup: boolean;
  autoId: string;
  type: string;
  tileThumbnail: AssetThumbnailViewModel[] = [];
  uploadThumbnailSortValue = GlobalConstants.UPLOAD_DATE;
  uploadDateOption = GlobalConstants.UPLOAD_DATE;
  fileNameOption = GlobalConstants.FILE_NAME;
  thumbnailName: string;
  thumbnailAssetId: string;
  thumbnailAssetIdArray: string[];
  assetId: any;
  thumbnail: AssetThumbnailViewModel[] = [];
  isThumbnailSelected: boolean;
  isContentNameNotUnique: boolean;
  lang: string[];
  selectedLangauge = [] as any;
  selectedLangaugeName = [] as any;
  isLanguageEmpty: boolean;
  isPartnerContentLanguage: boolean;
  sytsemIdSelectedLanguage: string[] = [];
  language: string;
  thumbnailSelected = false;
  popDisplay: string = "English Display Name";
  enterContentNamePlaceHolder = OemConstants.enterContentNamePlaceHolder;
  tileCtaPlaceHolder = OemConstants.tileCtaPlaceHolder;
  langCatPlaceHolder = OemConstants.langCatPlaceHolder;
  TileThumbnailPreviewData: TileThumbnailPreview;
  pageType: string = GlobalConstants.PARTNER_CONTENT_CREATION;
  tabIndex = 1;
  allLanguages: boolean;
  allLanguagesShow: boolean = true;
  configurationData: any;
  @Output() sendDataToPage = new EventEmitter();
  dataForPage;
  isEdit: boolean;
  lanuageEdit: any;
  isEditImage: boolean;
  popUpOpen: boolean;
  editContentId: any;
  editAutoId: any;
  isTileDataEmpty: boolean;
  assetsData = [] as any;
  disableImage = true;
  skuListData = [] as any;
  systemIdSearch = OemConstants.STATIC_VALUE_MODEL_SKU_INFO;
  bgColor: string;
  constructor(
    private oemservice: OemService,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private router: Router,
    private logoContentService: PromoContentService,
    private cmnService: CommonService,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) { }

  ngOnInit(): void {
    this.isEdit = false;
    this.TileThumbnailPreviewData = {
      image: {
        name: '',
        url: '',
        format: ''
      },
      bgColor: '#000000'
    }
    this.isSystemIdSelected = false;
    this.isPartnerContentLanguage = true;
    this.isThumbnailSelected = false;
    this.isLanguageEmpty = true;
    this.getModelSKUInfo();
    this.createPartnerContentGroupForm();
    if (this.getEditData || this.duplicacy) {
      this.isEdit = true;
      this.isEditImage = true;
      this.popUpOpen = true;
      this.dataForPage = this.getEditData;
      this.editContentId = this.getEditData.contentID;
      this.editAutoId = this.getEditData.autoID;
      this.lanuageEdit = typeof this.getEditData.languages === 'string' || this.getEditData.languages ? JSON.parse(this.getEditData.languages) : this.getEditData.configurations.languages;
      this.configurationData = typeof this.getEditData.configurations === 'string' ? JSON.parse(this.getEditData.configurations) : this.getEditData.configurations;
      this.selectSystemID(undefined, this.getEditData.autoID, this.configurationData.systemID);
      this.partnerContentgrpForm.controls.contentName.setValue(this.configurationData.contentName);
      this.partnerContentgrpForm.controls.tileCTA.setValue(this.configurationData.tileCTA);
      this.partnerContentgrpForm.controls.languageCategory.setValue(this.configurationData.languageCategory);
      this.bgColor = this.configurationData?.bgColor ? this.configurationData?.bgColor : "#000000";
      setTimeout(() => {
        this.getAllThumnailByAutoId();
      }, 0);
      this.partnerContentgrpForm.controls.tileThumbnail.setValue(this.configurationData.contentName);
      this.partnerContentgrpForm.controls.languages.setValue(this.configurationData.contentName);
      setTimeout(() => {
        if(!this.duplicacy){
          this.openMultiSelectLanguageModal();
        }
        this.popUpOpen = this.duplicacy;
      }, 0);
    }
    this.cmnService.emitDataToLivePreview({ page: GlobalConstants.PARTNER_CONTENT_CREATION, dataSet: {bgColor : this.bgColor} });
  }

  getModelSKUInfo() {
    this.oemservice.getAllModelSKUFunc('updatedTime', 'desc')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getAllModelSkuInfo => {
        this.modelSkuList = getAllModelSkuInfo.modelSKUs as ModelSKU[];
        this.skuListData = this.modelSkuList.map(skuData => skuData.systemID);

      });
  }

  selectSystemID(event, autoId?: string, systemId?: string) {
    this.isSystemIdSelected = true;
    this.thumbnailName = '';
    this.partnerContentgrpForm.controls.contentName.enable();
    this.partnerContentgrpForm.controls.tileCTA.enable();
    this.partnerContentgrpForm.controls.languageCategory.enable();
    // UAT-404 Starts
    if (event !== undefined) {
      this.valueModelSKUInfo = event.autoID;
      this.selectedAutoId = event.autoID;
      this.selectedSystemId = event.systemID;
    }
    else {
      this.valueModelSKUInfo = systemId;
      this.selectedAutoId = autoId;
      this.selectedSystemId = systemId;
    }
    this.oemservice.getModelSKUDataByAutoID(this.selectedAutoId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getAllModelSkuInfoByAutoID => {

        this.modelSkuListDataByAutoId = getAllModelSkuInfoByAutoID.modelSKU as ModelSKU[];
        this.displayName = this.modelSkuListDataByAutoId["displayName"];

        if (typeof this.parseJson(this.displayName) === 'object') {
          var disName = JSON.parse(this.modelSkuListDataByAutoId["displayName"]);
          for (let element in disName) {
            if (element === 'en_US') {
              this.englishDisplayName = disName[element];
            }
          }
        } else {
          this.englishDisplayName = this.displayName
        }
        try {
          this.systemModel = JSON.parse(this.modelSkuListDataByAutoId["systemModels"])
          let temp = this.systemModel;
          this.displaySytemModel = temp.join(", ");
        } catch {
          let temp = [];
          temp.push(this.modelSkuListDataByAutoId["systemModels"]);
          this.displaySytemModel = temp;
        }
      })
    this.getContentBySystemId();
  }

 // UAT-404 Ends
  parseJson(code) {
    try {
      return JSON.parse(code);
    } catch (e) {
      return code;
    }
  }
  getContentBySystemId() {
    this.oemservice.getContentBySystemIdFilter(this.selectedSystemId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(allPartnerContent => {
        this.sytsemIdSelectedLanguage = [];
        let lang = allPartnerContent.contents.map(content => {
          this.lang = JSON.parse(content.languages);
          let data = this.lang.map(lang => {
            this.sytsemIdSelectedLanguage.push(lang);
            if (this.isSystemIdSelected && this.sytsemIdSelectedLanguage.length >= 32 && !this.editCG) {
              this.isAllLanguagesSelected = true;
            } else {
              this.isAllLanguagesSelected = false;
            }
          })
        })
        if(this.duplicacy){
          if(this.sytsemIdSelectedLanguage.length < 31){
            this.openMultiSelectLanguageModal();
          }
          this.isAllSelectLang.emit(this.sytsemIdSelectedLanguage)
        }

      })

  }

  createPartnerContentGroupForm() {
    this.partnerContentgrpForm = this.formBuilder.group({
      contentName: [{ value: '', disabled: true }, Validators.required],
      tileCTA: [{ value: '', disabled: true }, Validators.required],
      languageCategory: [{ value: '', disabled: true }, Validators.required],
      tileThumbnail: new FormControl(''),
      languages: new FormControl('')
    })
    this.bgColor = "#000000";
  }


  cancel() {
    this.isSubmitted = false;
    this.isEdit = false;
    this.isEditImage = false;
    this.thumbnail = [];
    this.getEditData = undefined;
    this.goBacktoPromoContent.emit({ cancel: true });
    this.editDone.emit(true);
  }

  selectThumbnailPopup() {
    this.selectTileThumbnailPopup = true;
    this.tileThumbnail = [];
    this.isTileDataEmpty = false;
    this.getAllThumnailByAutoId();
  }

  closeSelectThumbnailPopup() {
    this.selectTileThumbnailPopup = false;
    this.tileThumbnail = [];
  }

  selectedThumbnail(id: string, event) {
    this.thumbnail = event;
    this.tileThumbnail.forEach(ele => {
      if (ele.assetID === id) {
        this.thumbnailSelected = event;
        ele.selectedThumbnail = true;
        this.disableImage = false;
      } else {
        ele.selectedThumbnail = false;
      }
    });
  }

  finalThumbnailSelected(tileThumbnail) {
    this.isThumbnailSelected = (tileThumbnail.assetID) ? true : false;
    this.thumbnailAssetId = tileThumbnail.assetID;
    this.thumbnailAssetIdArray = this.thumbnailAssetId.split(",");
    this.thumbnailName = tileThumbnail.assetName;
    this.selectTileThumbnailPopup = false;
    this.TileThumbnailPreviewData.image.url = tileThumbnail.imageData;
    this.TileThumbnailPreviewData.bgColor = this.bgColor;
    this.cmnService.emitDataToLivePreview({ page: GlobalConstants.PARTNER_CONTENT_CREATION, dataSet: this.TileThumbnailPreviewData });
  }

  getAllThumnailByAutoId() {
    this.type = OemConstants.TILE_THUMBNAIL
    this.oemservice.getAllAssetsByAutoIdContent(this.type, this.selectedAutoId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(getAllAthumbnailResponse => {
        const thumbnail = [];
        const getThumnailByAutoId: GetAllTileThumbnailByAutoId = getAllAthumbnailResponse as GetAllTileThumbnailByAutoId;
        this.assetsData = getThumnailByAutoId.assets;
        this.isTileDataEmpty = (this.assetsData.length === 0) || false;
        getThumnailByAutoId.assets.forEach(assets => {
          const reader = new FileReader();
          const thumbnailViewModel: AssetThumbnailViewModel = assets as AssetThumbnailViewModel;

          this.oemservice.getAssetByAutoIdAndAssetIdContent(assets.assetID, OemConstants.SLASH_THUMBNAIL, this.selectedAutoId)
            .pipe(takeUntil(this.ngUnsubscribe))
            .pipe(first())
            .subscribe(imageData => {
              reader.addEventListener('load', () => {
                thumbnailViewModel.imageData = reader.result;
                thumbnailViewModel.fileName = assets.assetName;
                this.tileThumbnail.push(thumbnailViewModel);
                this.tileThumbnail.forEach(ele => {
                  if (this.thumbnailAssetId && ele.assetID == this.thumbnailAssetId) {
                    ele.selectedThumbnail = true;
                    this.disableImage = false;
                  } else {
                    ele.selectedThumbnail = false;
                    this.disableImage = true;
                  }
                  ele.shortFileName = this.getShortFileName(ele.fileName);
                  ele.updatedTime = new Date(ele.updatedTime);
                  ele.updateTimeDisplay = new Date(ele.updatedTime).toLocaleString()
                    .replace(',', '');
                })
                this.sortBy('uploadDate');
                if (this.isEditImage) {
                  let temp = this.tileThumbnail.filter(data => {
                    return data.assetID === this.configurationData.assetID
                  });
                  if (temp.length !== 0) {
                    this.selectedThumbnail(this.configurationData.assetID, temp[0]);
                    this.finalThumbnailSelected(temp[0]);
                    this.isEditImage = false;
                  }
                }
              }, false);

              if (imageData) {
                reader.readAsDataURL(imageData);
              }
            },

              error => {
                // do something
              });
        })
      },
        error => {
          // do something
        });
  }

  sortBy(sortValue: string) {
    switch (sortValue) {
      case 'uploadDate': {
        this.uploadThumbnailSortValue = GlobalConstants.UPLOAD_DATE;
        this.tileThumbnail.sort((logo1, logo2) => (logo2.updatedTime as any) - (logo1.updatedTime as any));
        break;
      }
      case 'fileName': {
        this.uploadThumbnailSortValue = GlobalConstants.FILE_NAME;
        this.tileThumbnail.sort((logo1, logo2) =>
          logo1.assetName.localeCompare(logo2.assetName));
        break;
      }
      default:
        break;
    }
  }


  getShortFileName(fileName: string): string {
    let finalName: string;
    if (fileName?.split('.')[0].length > 12) {
      let flname = fileName;
      let extension = fileName.substring(fileName.lastIndexOf('.') + 1);
      flname = fileName.substring(0, 12);
      finalName = `${flname}...${extension}`;
    } else {
      finalName = fileName;
    }
    return finalName;
  }

  createNewPartnerContent() {
    const partnerContent: PartnerContent = {
      configurations: '',
      contentName: this.partnerContentgrpForm.controls.contentName.value,
      tileCTA: this.partnerContentgrpForm.controls.tileCTA.value,
      languageCategory: this.partnerContentgrpForm.controls.languageCategory.value,
      languages: '',
    }
    const configuration: PartnerContentConfiguration = {
      systemID: this.selectedSystemId,
      languages: this.selectedLangauge,
      languageCategory: this.partnerContentgrpForm.controls.languageCategory.value.trim(),
      contentName: this.partnerContentgrpForm.controls.contentName.value.trim(),
      tileCTA: this.partnerContentgrpForm.controls.tileCTA.value.trim(),
      assetID: this.thumbnailAssetId,
      assetName: this.thumbnailName,
      assetType: this.thumbnailName.split('.')[1],
      type: 'partnerContentGroup',
      contentGroupPages: [],
      bgColor: this.bgColor
    }
    partnerContent.languages = JSON.stringify(this.selectedLangauge);
    partnerContent.configurations = JSON.stringify(configuration);
    if (this.isEdit) {
      partnerContent.action = 'save';
      configuration.contentGroupPages = this.configurationData.contentGroupPages;
      partnerContent.configurations = JSON.stringify(configuration);
      if(this.duplicacy) {
        this.newContentService(partnerContent);
        this.changedContentName.emit(this.partnerContentgrpForm.controls.contentName.value)
      } else {
        this.editContentService(partnerContent);
      }
    } else {
      this.newContentService(partnerContent);
    }
  }

  onAdd() {
    this.isSubmitted = true;
    this.createNewPartnerContent()
  }

  editContentService(partnerContent){
    this.oemservice.EditPartnerContent(JSON.stringify(partnerContent), this.editContentId, this.editAutoId)
    .pipe(takeUntil(this.ngUnsubscribe))
    .pipe(first())
    .subscribe(response => {
      const editPartnerContentResponseObj: CreatePartnerContentContentResponse = response as CreatePartnerContentContentResponse;
      this.sendDataToPage.emit(this.dataForPage);
      this.goBacktoPromoContent.emit(editPartnerContentResponseObj);
      this.isEdit = false;
      this.editDone.emit(response.content);
    },
      (err) => {
        if (err.responseContext.exceptionResponse.errorMessage) {
          this.isContentNameNotUnique = true;
        }
      });
  }

  newContentService(partnerContent){
    this.oemservice.createNewPartnerContent(JSON.stringify(partnerContent), this.selectedAutoId)
    .pipe(takeUntil(this.ngUnsubscribe))
    .pipe(first())
    .subscribe(createPartnerContentResponse => {
      const createPartnerContentResponseObj: CreatePartnerContentContentResponse = createPartnerContentResponse as CreatePartnerContentContentResponse;
      this.goBacktoPromoContent.emit(createPartnerContentResponseObj);
      this.googleAnalyticsService.newContentGroupCreated();
      this.editDone.emit(createPartnerContentResponse.content);
    },
      (err) => {
        if (err.responseContext.exceptionResponse.errorMessage) {
          this.isContentNameNotUnique = true;
        }
      }
    );
  }

  goBack() {
    this.isSubmitted = false;
    this.editDone.emit(true);
    this.goBacktoListPartnerContent.emit({ tabIndex: 0 })
    this.showAuthorTabs.emit(true);
    this.isNewPartnerContent.emit(false);
  }

  goToCreateNewModelSku() {
    this.router.navigate([RouterConstants.CREATE_MODEL_SKU_INFO]);
  }

  openMultiSelectLanguageModal() {
    this.openModal(this.profileLanguageModal);
  }

  updateLanguageDetails(data) {
    this.selectedLangauge = data.userSelectedLanguage;
    this.selectedLangaugeName = data.userSelectedLanguageName;
    this.isLanguageEmpty = !(this.selectedLangauge.length > 0);
    this.allLanguages = data.allLang;
    this.allLanguagesShow = data.allLang
    this.closeModal(this.profileLanguageModal);
  }

  openModal(modal: any) { modal.open(); }
  closeModal(modal: any) { modal.close(); }

  contentNameChange() {
    this.isContentNameNotUnique = false;
  }
  closePopup() {
    this.isSystemIdSelected = false;
    this.isAllLanguagesSelected = false;
    this.valueModelSKUInfo = null;
  }

  redirectToModelSku() {
    this.selectTileThumbnailPopup = false;
    this.router.navigate([RouterConstants.EDIT_SKU, this.selectedAutoId]);
  }
  emitPageDataToPreview(){
    this.cmnService.emitDataToLivePreview({ page: GlobalConstants.PARTNER_CONTENT_CREATION, dataSet: {bgColor : this.bgColor} });
  }
}
